import React from "react"
import {Box} from "@mui/material"
import configRelativePathURL from "../../../../utils/configUrlPath"
import SnailItemIcon from "../../../SnailItemIcon"
import {Icons, Link} from "../../../../models/secondary-nav"
import {
    BurgerSecondaryNavSectionLink,
    BurgerSecondaryNavSectionLinks,
    BurgerSecondaryNavSectionTitle,
    BurgerSecondaryNavLink,
    StyledBox,
    BurgerSecondaryNavCategoryTitle,
} from "./component"

export type BurgerSecondaryNavSectionProps = {
    title?: string | null
    englishTitle?: string | null | undefined
    englishDepartment: string | null | undefined
    blockLinks?: Link[]
    department: string
    isImagePlaceholderEnabled: boolean
    icons: Icons[] | undefined
    realm: string
    isFirstSection: boolean
    testingVariant?: string | null
    siteUrl: string
}

export const BurgerSecondaryNavSection = ({
    title,
    englishTitle,
    blockLinks,
    department,
    englishDepartment,
    isImagePlaceholderEnabled,
    icons,
    realm,
    isFirstSection = false,
    testingVariant,
    siteUrl,
}: BurgerSecondaryNavSectionProps) => {
    if (title) {
        return (
            <StyledBox isFirstSection={isFirstSection}>
                <BurgerSecondaryNavSectionTitle>
                    {isImagePlaceholderEnabled && <SnailItemIcon icons={icons} realm={realm} />}
                    <BurgerSecondaryNavCategoryTitle variant="subtitle2">{title}</BurgerSecondaryNavCategoryTitle>
                </BurgerSecondaryNavSectionTitle>
                <BurgerSecondaryNavSectionLinks>
                    {blockLinks?.map(link => (
                        <BurgerSecondaryNavSectionLink key={link.target}>
                            <BurgerSecondaryNavLink
                                variant="body1"
                                href={configRelativePathURL(link.target, siteUrl)}
                                data-ga-v1-mp={department}
                                data-ga-v2-mp={title}
                                data-ga-v3-mp={link.title}
                                data-ga-v1={englishDepartment || department}
                                data-ga-v2={englishTitle || title}
                                data-ga-v3={link.englishTitle || link.title}
                                data-ga-v5={testingVariant}
                            >
                                {link.title}
                            </BurgerSecondaryNavLink>
                        </BurgerSecondaryNavSectionLink>
                    ))}
                </BurgerSecondaryNavSectionLinks>
            </StyledBox>
        )
    }

    return (
        <Box>
            {blockLinks?.map(link => (
                <BurgerSecondaryNavSectionTitle key={link.target}>
                    {isImagePlaceholderEnabled && <SnailItemIcon icons={icons} realm={realm} />}
                    <BurgerSecondaryNavLink
                        variant="body1"
                        href={configRelativePathURL(link.target, siteUrl)}
                        data-ga-v1-mp={department}
                        data-ga-v2-mp={title}
                        data-ga-v3-mp={link.title}
                        data-ga-v1={englishDepartment || department}
                        data-ga-v2={englishTitle || title}
                        data-ga-v3={link.englishTitle || link.title}
                        data-ga-v5={testingVariant}
                    >
                        {link.title}
                    </BurgerSecondaryNavLink>
                </BurgerSecondaryNavSectionTitle>
            ))}
        </Box>
    )
}

export default BurgerSecondaryNavSection
